import m from "../../geodata/es2015/israelHigh";
window.am4geodata_israelHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/israelHigh.js
// module id = null
// module chunks = 